module.exports = __webpack_public_path__ + "files/c7c2b3534d79c699a86d92505b75d0e9.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-96x96.png
// module id = 1250
// module chunks = 76